"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnscopeUserWatcher = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var SingleWatcher_1 = require("./SingleWatcher");
var getUnscopeUserRefClient_1 = require("../../functions/utilities/ref/get/getUnscopeUserRefClient");
var firestore_1 = require("firebase/firestore");
var react_redux_1 = require("react-redux");
var react_redux_2 = require("react-redux");
var description = 'UnscopeUserWatcher';
exports.UnscopeUserWatcher = (0, react_1.memo)(function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var userId = (0, react_redux_2.useSelector)(function (state) {
        return state.currentUserId || '';
    });
    var refCallback = (0, react_1.useCallback)(function () {
        if (userId) {
            return (0, getUnscopeUserRefClient_1.getUnscopeUserRefClient)({
                firestore: (0, firestore_1.getFirestore)(),
                userId: userId,
            });
        }
        return null;
    }, [userId]);
    var onNextCallback = (0, react_1.useCallback)(function (docSnapshot) {
        var item = docSnapshot.data() || {};
        dispatch({
            type: 'GET_UNSCOPE_USER_SUCCESS',
            description: description,
            requestValues: {
                userId: userId,
            },
            successValues: {
                item: item,
            },
        });
    }, [userId, dispatch]);
    var watcherKey = 'unscopeUserWatcher';
    return (react_1.default.createElement(SingleWatcher_1.SingleWatcher, { onNext: onNextCallback, getRef: refCallback, watcherKey: watcherKey }));
});
